module.exports = __webpack_public_path__ + "img/login_header_logo.209e1c2a.jpg";